module.exports = __webpack_public_path__ + "static/logo1-8d1003667654b871c25f881086ceba32.png";